export default __webpack_public_path__ + "static/media/add_prescription.ea2c5adc.svg";